import { useEffect } from "react";
import { useSelector } from "react-redux";
import { State } from "../../app/store";

const BASE_TITLE = "eAktywni";

export const useDocumentTitleWithFacility = () => {
  const configuration = useSelector((state: State) => state.config.configuration);

  useEffect(() => {
    if (!configuration || Object.keys(configuration).length === 0) {
      document.title = BASE_TITLE;
      return;
    }

    const facilityName = configuration.facilityName;

    if (facilityName) {
      document.title = `${BASE_TITLE} – ${facilityName}`;
    } else {
      document.title = BASE_TITLE;
    }
  }, [configuration]);
};

